import { render, staticRenderFns } from "./AdminTasks.vue?vue&type=template&id=d3e10bbe&scoped=true"
import script from "./AdminTasks.vue?vue&type=script&lang=ts"
export * from "./AdminTasks.vue?vue&type=script&lang=ts"
import style0 from "./AdminTasks.vue?vue&type=style&index=0&id=d3e10bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e10bbe",
  null
  
)

export default component.exports